module.exports = __webpack_public_path__ + "files/8a302b9d26d5d4e346500c4db0c1ff1f.png";